// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checklist_checkbox__2YqTE","checkableItem":"Checklist_checkableItem__1Vry0","noTab":"Checklist_noTab__2f9LE"};